function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaudiSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 496 496",
    style: {
      enableBackground: "new 0 0 496 496"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#009966"
    },
    d: "M496,369.6c0,27.2-21.6,48.8-48,48.8H48c-26.4,0-48-21.6-48-48.8V126.4c0-27.2,21.6-48.8,48-48.8h400 c26.4,0,48,21.6,48,48.8V369.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#038E5C"
    },
    d: "M48,77.6h400c26.4,0,48,21.6,48,48.8v243.2c0,27.2-21.6,48.8-48,48.8"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007A54"
    },
    d: "M496,369.6c0,27.2-21.6,48.8-48,48.8H48c-26.4,0-48-21.6-48-48.8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007A54"
    },
    d: "M48,77.6h400c26.4,0,48,21.6,48,48.8v88.8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M60.8,155.2c3.2-2.4,3.2,4,0,11.2c1.6-2.4,4.8-8,4-12c-0.8-5.6-4-4.8-6.4-1.6 C56.8,155.2,57.6,156.8,60.8,155.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M61.6,200.8c4-7.2,2.4-12.8,5.6-23.2c2.4-6.4,2.4-1.6,2.4,2.4c-1.6,10.4-0.8,27.2,13.6,26.4 c0.8,9.6,3.2,26.4,3.2,32.8c0,5.6,0.8,4,2.4,0.8c1.6-3.2,0.8-7.2,0.8-12c0-4.8-0.8-13.6-1.6-25.6c1.6-1.6,4-4,4.8-5.6 c1.6-4,2.4-3.2,3.2,0c1.6,6.4,8,10.4,16,4c8-5.6,4.8-16.8,0.8-28.8c3.2,0.8,4-1.6,2.4-4.8c-0.8-1.6-2.4-3.2-3.2-4.8 c-1.6-1.6-2.4-3.2-4-1.6s-2.4,3.2-3.2,4c-0.8,0.8-0.8,2.4,0,4.8c3.2,7.2,4.8,15.2,5.6,19.2c0.8,4-0.8,4.8-4,4.8 c-2.4,0-6.4-0.8-8-7.2s-2.4-8.8-1.6-13.6c0-4,0.8-7.2-2.4-11.2c-3.2-4-3.2-3.2-4-1.6c-0.8,2.4-1.6,5.6-0.8,9.6 c1.6,5.6,2.4,10.4,3.2,13.6c0.8,2.4-1.6,7.2-5.6,9.6c-0.8-8-1.6-17.6-2.4-26.4c4.8-1.6,2.4-7.2-1.6-13.6c-2.4-4.8-4-3.2-5.6,0 c-1.6,3.2-0.8,4.8,0.8,7.2c-0.8,2.4,0.8,5.6,1.6,11.2c0.8,4,1.6,14.4,1.6,23.2c-3.2,0-5.6-2.4-7.2-5.6c-2.4-6.4-2.4-12.8-0.8-16 c1.6-4,2.4-9.6,0-11.2s-4.8,0-6.4,3.2c-3.2,4.8-6.4,11.2-6.4,18.4c0,2.4-0.8,8-2.4,10.4c-0.8,2.4-3.2,2.4-4.8-0.8 c-3.2-4.8-4-17.6-4-24c0-3.2-0.8-4-1.6,0c-3.2,12.8,0.8,25.6,3.2,31.2C55.2,207.2,59.2,205.6,61.6,200.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M100,159.2c1.6-1.6,1.6-1.6,2.4,0s3.2,1.6,4,0s1.6-2.4,0.8-4.8c-0.8-1.6-0.8-0.8-1.6,0.8 c-0.8,3.2-4,2.4-4-1.6s-0.8-1.6-2.4,0.8c-1.6,4-4,3.2-4-0.8c0-2.4-0.8-4.8-2.4-1.6c-0.8,2.4,0,4.8,0.8,6.4 C96,160.8,98.4,160.8,100,159.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M76,219.2c2.4-0.8,2.4-0.8,2.4-4c0-3.2-1.6-1.6-4.8-0.8c-4.8,1.6-14.4,6.4-21.6,15.2 c-3.2,4-0.8,2.4,1.6,0.8C57.6,227.2,69.6,220.8,76,219.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M60,270.4c-2.4,4-7.2-1.6-4-12c0.8-2.4,1.6-4,1.6-5.6s0-3.2,0-5.6c0-1.6-1.6,0.8-2.4,4 c-0.8,4.8-4,7.2-3.2,22.4c0.8,8.8,11.2,8.8,12-2.4C64,266.4,62.4,266.4,60,270.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M131.2,236.8c0-4-0.8-8-0.8-12c0.8,0,0.8-0.8,1.6-0.8c2.4,7.2,12.8,5.6,16,0.8 c1.6-2.4,1.6-2.4,3.2,0c2.4,3.2,10.4,4.8,12,0c1.6-4.8,1.6-9.6,0.8-12.8c-0.8-4-1.6-3.2-4-1.6c-2.4,1.6-0.8,2.4,0,4.8 c0.8,9.6-7.2,8.8-8-0.8c-0.8-6.4-1.6-4-2.4-0.8c-4,12-14.4,14.4-12.8,0c0-4-2.4-2.4-4-0.8c-0.8,0.8-2.4,2.4-3.2,3.2 c-0.8-11.2-1.6-24-3.2-40c3.2,4,6.4-0.8,4-4.8c-1.6-3.2-4-11.2-5.6-15.2s-2.4-3.2-5.6,0.8c-3.2,3.2-2.4,4-1.6,8 c0,4.8,0,8.8,1.6,17.6c0.8,6.4,2.4,20,4,36.8c-1.6,0.8-4,2.4-5.6,3.2c-0.8-3.2-3.2-4.8-6.4-8c-4.8-4.8-8-4.8-12,0.8 s-3.2,6.4-3.2,12c0,4.8-0.8,6.4,3.2,8s5.6,0.8,8,0c1.6-0.8,4-1.6,7.2-2.4c0.8,2.4,0,5.6-1.6,7.2c-9.6,11.2-24,20-30.4,12 c-3.2-4-4.8-10.4-4-18.4c0.8-6.4-0.8-3.2-1.6-1.6c-2.4,7.2-3.2,18.4,0,24c4,8,11.2,11.2,22.4,5.6c11.2-4.8,21.6-13.6,21.6-25.6 c0-2.4,0-4,0-5.6c1.6-0.8,3.2-1.6,4-2.4c0,4,0,9.6,0,13.6c0.8,12.8-4.8,16.8-9.6,20.8c-6.4,4.8-15.2,8.8-23.2,9.6 c-17.6,2.4-21.6-8.8-21.6-24c0-2.4,0.8-4,0.8-7.2c0-6.4-0.8-5.6-3.2,0.8c-1.6,6.4-4,20.8,1.6,32.8c6.4,12,27.2,8.8,43.2,0.8 C130.4,266.4,132,252,131.2,236.8z M108.8,224.8c-4,1.6-5.6-0.8-4.8-3.2c0-2.4,0.8-4,4-2.4c1.6,0.8,3.2,2.4,4.8,4.8 C110.4,224.8,109.6,224.8,108.8,224.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M149.6,250.4c1.6-3.2,2.4-6.4,1.6-10.4c-0.8-2.4,0-3.2-2.4-4.8c-2.4-0.8-3.2,0.8-4,2.4 c-0.8,2.4,0.8,5.6,4,4c0.8,1.6,0,5.6-0.8,8C147.2,252.8,148,253.6,149.6,250.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M156,185.6c-3.2,4-5.6,9.6-0.8,12.8c2.4,1.6,7.2-0.8,8.8-4c1.6-4,0.8-4.8-2.4-0.8 c-4,4.8-8.8,0.8-4-6.4C160.8,182.4,158.4,181.6,156,185.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M142.4,186.4c11.2-4.8,17.6-11.2,20.8-16.8c3.2,0.8,4-1.6,2.4-4c0.8-2.4,1.6-4,2.4-5.6 c2.4-10.4-8-11.2-10.4-3.2c-1.6,4-1.6,8,1.6,10.4c-4.8,6.4-11.2,12-19.2,16.8C136.8,187.2,137.6,188.8,142.4,186.4z M161.6,158.4 c0.8-2.4,2.4-0.8,2.4,0.8c0,0.8-0.8,2.4-1.6,3.2C160.8,161.6,160.8,160,161.6,158.4z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CFE7E8"
    },
    d: "M157.6,156.8c-1.6,4-1.6,8,1.6,10.4c-0.8,0.8-1.6,2.4-2.4,3.2l4,3.2c0.8-1.6,2.4-2.4,3.2-4 c3.2,0.8,4-1.6,2.4-4c0.8-2.4,1.6-4,2.4-5.6C170.4,149.6,160.8,148.8,157.6,156.8z M164,159.2c0,0.8-0.8,2.4-1.6,3.2 c-1.6-0.8-1.6-2.4-0.8-4C162.4,156,164,157.6,164,159.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M169.6,250.4c-1.6,0.8-4,3.2-5.6,4.8c0-3.2,0.8-8,0.8-9.6c0-2.4-0.8-3.2-2.4-0.8 c-2.4,4.8-4.8,11.2-5.6,16c-10.4,7.2-23.2,14.4-32,18.4c-4,1.6-1.6,3.2,1.6,2.4c12-4,21.6-7.2,30.4-11.2c0.8,7.2,3.2,12,9.6,13.6 c12,3.2,24-7.2,37.6-25.6c3.2,8.8,11.2,20.8,32,24c8.8,1.6,8,0.8,9.6-4c0.8-4,2.4-4.8-4.8-6.4c-8.8-3.2-12-9.6-3.2-13.6 s20.8-7.2,28.8-8.8c5.6-0.8,7.2-0.8,8.8-5.6c1.6-5.6,2.4-6.4-3.2-5.6c-6.4,0.8-36.8,1.6-44.8,0.8c6.4-3.2,15.2-6.4,21.6-8.8 c2.4,1.6,3.2,0.8,2.4-0.8c2.4-0.8,4.8-1.6,7.2-3.2c7.2-4,10.4-12.8,2.4-18.4s-14.4-7.2-18.4-1.6c-3.2,4.8-6.4,9.6-1.6,16 c-7.2,2.4-13.6,4.8-20,7.2c-4.8,1.6-7.2,2.4-8.8,8.8s-2.4,6.4,4,7.2c8.8,0,16.8,0,22.4,4.8c-8.8,3.2-15.2,9.6-12,18.4 c-4-0.8-8-2.4-11.2-5.6c-6.4-6.4-6.4-17.6-8.8-30.4c-2.4-12.8-8-24-10.4-28.8c-1.6-4.8-2.4-2.4-4,0.8c-1.6,3.2-3.2,4.8-1.6,9.6 c3.2,8,8,24,10.4,33.6c-4.8,11.2-17.6,24.8-28,26.4c-8,1.6-10.4-3.2-9.6-7.2c5.6-3.2,10.4-7.2,15.2-12c9.6-10.4,11.2-18.4,4.8-35.2 c4,0.8,3.2-2.4-2.4-9.6c-4-4.8-4.8-4-7.2,0.8c-1.6,4-3.2,7.2,1.6,8.8c0.8,2.4,2.4,5.6,4.8,9.6C184.8,240,176.8,244,169.6,250.4z  M245.6,215.2c0-2.4,0.8-2.4,4.8,0c4,2.4,7.2,3.2,1.6,4c-1.6,0.8-4,0.8-5.6,1.6C246.4,218.4,246.4,216.8,245.6,215.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CFE7E8"
    },
    d: "M271.2,238.4c-4,0-21.6,0.8-33.6,0.8l16,13.6c4-1.6,8.8-2.4,12-3.2c5.6-0.8,7.2-0.8,8.8-5.6 C276,238.4,276.8,237.6,271.2,238.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CFE7E8"
    },
    d: "M192.8,200.8l1.6,1.6C194.4,200.8,193.6,200.8,192.8,200.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CFE7E8"
    },
    d: "M233.6,235.2c4.8-2.4,10.4-4,14.4-5.6c2.4,1.6,3.2,0.8,2.4-0.8c2.4-0.8,4.8-1.6,7.2-3.2 c7.2-4,10.4-12.8,2.4-18.4c-8-5.6-14.4-7.2-18.4-1.6c-3.2,4.8-6.4,9.6-1.6,16c-5.6,1.6-10.4,3.2-15.2,5.6L233.6,235.2z  M251.2,215.2c4,2.4,7.2,3.2,1.6,4c-1.6,0.8-4,0.8-5.6,1.6c-0.8-2.4-0.8-4-0.8-4.8C245.6,212.8,247.2,212.8,251.2,215.2z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M264,280c2.4-0.8,6.4-3.2,9.6-5.6c3.2-3.2,0.8-2.4-1.6-1.6s-4.8,2.4-8,3.2c-3.2,1.6-4,0-2.4-5.6 c1.6-4.8,0-4.8-2.4-4s-3.2,2.4-5.6,4c-1.6,0.8-1.6,2.4,2.4,0.8c3.2-1.6,2.4,0,1.6,4C256,279.2,258.4,281.6,264,280z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CFE7E8"
    },
    d: "M189.6,192.8c2.4-5.6,4-11.2,5.6-15.2s3.2-3.2,2.4,0.8c-0.8,7.2-0.8,18.4,6.4,23.2 c7.2,4,18.4-3.2,22.4-11.2c12,15.2,22.4,8,23.2-6.4c0-4.8-1.6-14.4-3.2-17.6c-1.6-3.2,0-3.2,1.6-1.6c1.6,1.6,4.8,3.2,3.2-2.4 c-1.6-4.8-4-8-6.4-10.4s-3.2-0.8-4,0.8s-0.8,2.4-2.4,4s-0.8,2.4,0,4.8c4.8,11.2,8.8,28,1.6,29.6c-6.4,1.6-10.4-12.8-10.4-19.2 c0-8-1.6-15.2-3.2-20c-1.6-4.8-2.4-4.8-4-2.4c-0.8,1.6-0.8,3.2-2.4,4.8c-0.8,1.6,0,2.4,0.8,5.6c4,18.4,3.2,26.4-4.8,31.2 c-8,4.8-12.8,0-12.8-5.6s0-12.8,0.8-17.6c0.8-4.8,1.6-6.4,0-8.8s-3.2-1.6-5.6,1.6c-4.8,7.2-10.4,19.2-12,24.8s-5.6,4-8-0.8 c-3.2-5.6-2.4-16-1.6-20.8c0.8-4,0.8-5.6-1.6-1.6c-4,11.2-4,22.4,4.8,32C184,201.6,187.2,198.4,189.6,192.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CFE7E8"
    },
    d: "M212,171.2c0,2.4,0,5.6,1.6,0.8c0.8-4.8,0.8-11.2-0.8-15.2s-2.4-4.8-4-3.2s-1.6,2.4,0,4 C210.4,160,212.8,165.6,212,171.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CFE7E8"
    },
    d: "M228.8,208.8c0,6.4-1.6,6.4-4,0c-0.8-2.4-1.6-2.4-2.4,0.8c0,5.6-2.4,6.4-4,0.8 c-0.8-2.4-0.8-4.8-1.6-0.8c-0.8,3.2,0,5.6,1.6,8c1.6,1.6,4,1.6,4.8-0.8s1.6-2.4,3.2-0.8c1.6,1.6,8,0,4.8-8.8 C229.6,204,228.8,204.8,228.8,208.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CFE7E8"
    },
    d: "M293.6,158.4c2.4,1.6,4.8,5.6,4,10.4c-0.8,4,0,6.4,2.4,0.8c2.4-5.6,0.8-12-1.6-16s-3.2-2.4-4.8-0.8 C292,155.2,291.2,157.6,293.6,158.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CFE7E8"
    },
    d: "M252.8,160.8c0,2.4,0.8,4,4,4.8c6.4,8.8,13.6,18.4,20,27.2c0.8,8,2.4,16,3.2,23.2 c1.6,16,4.8,37.6,2.4,47.2c-1.6,7.2,0,9.6,3.2-0.8s3.2-20.8,0.8-36c-0.8-6.4-0.8-13.6-1.6-21.6c10.4,16.8,20.8,32.8,24.8,44 c2.4,6.4,4.8,7.2,2.4-0.8c-2.4-11.2-12.8-30.4-28.8-54.4c-0.8-6.4-0.8-12.8-0.8-17.6c2.4,2.4,4,0.8,3.2-2.4 c-1.6-6.4-4-11.2-6.4-17.6c-0.8-3.2-4-3.2-5.6,0.8c-1.6,4.8-1.6,5.6,0,8.8c0,4,0.8,9.6,1.6,15.2c-2.4-4-6.4-9.6-9.6-13.6 c4,1.6,7.2,0.8,3.2-4c-4-4-9.6-8.8-12.8-12c-3.2-3.2-4.8-0.8-4.8,1.6C252.8,156.8,253.6,158.4,252.8,160.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CFE7E8"
    },
    d: "M298.4,183.2c-0.8,4-2.4,2.4-3.2-0.8c-0.8-1.6-1.6-0.8-1.6,2.4c0.8,3.2,1.6,5.6,4,3.2 c1.6-1.6,1.6-1.6,4,0c1.6,1.6,3.2,0,4-0.8c0-0.8,0.8-2.4,0-6.4s-1.6-1.6-2.4,1.6s-2.4,4-3.2,0C300,179.2,298.4,180,298.4,183.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CFE7E8"
    },
    d: "M316.8,235.2c0.8,14.4,2.4,20.8-6.4,31.2c-9.6,10.4-16,13.6-20,14.4c-5.6,1.6-7.2,4,0.8,3.2 c12-0.8,13.6-0.8,24-12.8c5.6-6.4,8-14.4,8-33.6c-0.8-33.6-4.8-48-4.8-66.4c1.6,1.6,4,1.6,3.2-1.6c-1.6-4-2.4-8.8-3.2-12.8 c-1.6-4-2.4-5.6-4-3.2c-1.6,2.4-3.2,3.2-4,4.8s-1.6,4,0,6.4C315.2,204,316,220.8,316.8,235.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CFE7E8"
    },
    d: "M337.6,239.2c0.8,8,2.4,13.6,0,23.2c-0.8,2.4,0.8,4,2.4,0c7.2-13.6,2.4-25.6,1.6-33.6 c-0.8-12-5.6-43.2-6.4-56l0.8,0.8c3.2,1.6,7.2,3.2,4.8-1.6c-2.4-4-4.8-11.2-6.4-16c-1.6-4.8-2.4-4.8-4.8-0.8 c-4.8,6.4-1.6,12.8,0,20.8C332.8,203.2,336.8,231.2,337.6,239.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CFE7E8"
    },
    d: "M354.4,194.4c2.4,2.4,4,7.2,5.6,9.6c1.6,4,3.2,0.8,3.2-1.6c0-2.4-0.8-9.6,0-12c1.6-4,4,1.6,4.8-0.8 c0.8-1.6-0.8-2.4-1.6-4c-0.8-2.4-1.6-1.6-3.2-0.8c-1.6,1.6-2.4,3.2-2.4,4c0,2.4,0,4.8,0,8.8c0,3.2-0.8,3.2-1.6,1.6 c-0.8-2.4-3.2-8-4.8-9.6c-1.6-1.6-4-0.8-4,1.6c0,2.4,0,1.6,0,4C350.4,196.8,353.6,196.8,354.4,194.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CFE7E8"
    },
    d: "M352.8,225.6c0,2.4,3.2-0.8,5.6-2.4s9.6-6.4,12.8-8c3.2-1.6,2.4-2.4,1.6-5.6c0-3.2-2.4-0.8-4.8,1.6 s-9.6,7.2-12,9.6S352.8,224,352.8,225.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CFE7E8"
    },
    d: "M336,268.8c-3.2-6.4-3.2-12.8-3.2-18.4c0-4.8-0.8-8.8-2.4-0.8c-4.8,19.2-1.6,23.2,3.2,27.2 c6.4,5.6,8.8,6.4,12,0.8c6.4-9.6,8.8-17.6,12-22.4c3.2-4,3.2-0.8,4.8,0.8c4,4.8,7.2,6.4,12.8,7.2c5.6,0.8,15.2-4,14.4-21.6 c-0.8-11.2-1.6-25.6-2.4-41.6c5.6,7.2,9.6,13.6,13.6,19.2c1.6,10.4,2.4,20,2.4,27.2c-0.8,8.8,1.6,8.8,3.2,0c0.8-3.2,0.8-11.2,0-20 c7.2,9.6,11.2,15.2,13.6,20c3.2,5.6,4.8,9.6,4-0.8c0-4-1.6-7.2-6.4-14.4c-4.8-6.4-8.8-12.8-12.8-19.2c-1.6-15.2-3.2-32-3.2-40.8 c2.4,1.6,4,0,2.4-3.2c-0.8-3.2-3.2-12.8-4.8-16c-1.6-3.2-3.2-3.2-4.8,0.8c-1.6,3.2-3.2,4.8-2.4,7.2c0.8,15.2,2.4,29.6,4.8,42.4 c-4-5.6-8-11.2-11.2-16c0-5.6-0.8-11.2-0.8-16.8c2.4,1.6,3.2,1.6,2.4-2.4c-0.8-3.2-4-11.2-5.6-14.4c-1.6-3.2-2.4-3.2-4-0.8 c-2.4,4-3.2,7.2-0.8,11.2c0,4,0.8,7.2,0.8,11.2c-2.4-3.2-4-6.4-6.4-8.8c2.4,0.8,4-0.8,1.6-3.2s-7.2-6.4-9.6-8.8c-2.4-3.2-4-2.4-4,0 s0,4.8,0,7.2s0,4,2.4,8c5.6,7.2,12,14.4,16.8,21.6c2.4,25.6,3.2,42.4,3.2,52.8c0,6.4-2.4,9.6-5.6,10.4c-3.2,0.8-6.4-0.8-9.6-5.6 c-5.6-8-8-6.4-12,0.8c-4,7.2-7.2,12.8-9.6,17.6C343.2,271.2,339.2,275.2,336,268.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CFE7E8"
    },
    d: "M412.8,180c0,4.8,1.6,4,2.4,0s0.8-12-1.6-16.8c-2.4-5.6-3.2-3.2-4-1.6c-1.6,2.4-1.6,3.2,0.8,5.6 C411.2,169.6,412.8,175.2,412.8,180z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CFE7E8"
    },
    d: "M434.4,229.6c-1.6-33.6-5.6-48-4.8-60.8c3.2,2.4,4,1.6,2.4-2.4s-4-8.8-5.6-13.6 c-1.6-4-2.4-3.2-4.8,0c-2.4,3.2-2.4,5.6-1.6,7.2c4.8,40.8,7.2,62.4,8,75.2c0.8,17.6-3.2,28-20.8,40c-5.6,4-12,8,1.6,4.8 C421.6,276,436,267.2,434.4,229.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CFE7E8"
    },
    d: "M389.6,264.8c-2.4,3.2,3.2,4.8,4,2.4c1.6,2.4,0,6.4-2.4,8.8c-4,3.2-1.6,4,0.8,1.6 c2.4-1.6,8.8-8.8,4.8-13.6C394.4,262.4,391.2,262.4,389.6,264.8z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M372,324c-10.4,0-20,0-30.4,0.8v-3.2c3.2-4,2.4-4,0-8c-0.8-1.6-1.6-3.2-4,0s-2.4,4,0.8,8v3.2 c-79.2,0.8-166.4,0-241.6-0.8c8,13.6,35.2,12.8,60,12.8c22.4,0,89.6,0,180.8-2.4v4c-3.2,4-2.4,4,0,8c2.4,3.2,3.2,1.6,4,0 c0.8-0.8,0.8-1.6,0.8-1.6h12c0,1.6,2.4,2.4,3.2,2.4c0.8,0,3.2-0.8,3.2-2.4h13.6c1.6,2.4,3.2,3.2,5.6,3.2c4.8,0,7.2-5.6,6.4-12.8 C385.6,324.8,381.6,323.2,372,324z M360.8,340c0-1.6-2.4-2.4-3.2-2.4c-0.8,0-3.2,0.8-3.2,2.4h-12c0-0.8-0.8-1.6-2.4-3.2v-4 c10.4,0,21.6-0.8,32.8-0.8c-0.8,2.4-0.8,4.8-0.8,7.2L360.8,340z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CFE7E8"
    },
    d: "M372,324c-10.4,0-20,0-30.4,0.8v-3.2c3.2-4,2.4-4,0-8c-0.8-1.6-1.6-3.2-4,0s-2.4,4,0.8,8v3.2 c0,0,0,0-0.8,0l11.2,9.6c8,0,16.8-0.8,24.8-0.8c-0.8,2.4-0.8,4.8-0.8,7.2h-12c0-1.6-2.4-2.4-3.2-2.4c-0.8,0-2.4,0.8-2.4,1.6l5.6,4.8 V344h13.6c1.6,2.4,3.2,3.2,5.6,3.2c4.8,0,7.2-5.6,6.4-12.8C385.6,324.8,381.6,323.2,372,324z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaudiSvg);
export default __webpack_public_path__ + "static/media/saudi-svg.5ea7aa9a9ebcc29a13c204f71b32ee13.svg";
export { ForwardRef as ReactComponent };